<div class="grid m-0 p-0">
  <div class="col-12 m-0 p-0">
    <!-- [(value)]="messages" -->
    <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
  </div>

  <ng-container card-body>
    <div *ngIf="(isLoading$ | async)" class="w-full flex align-items-center justify-content-center">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
  </ng-container>

  <div *ngIf="!(isLoading$ | async)" class="col-12 m-0 p-0 mt-4">

    <split-table card-body [dados]="(lista$ | async)!" theme="primary" [widthColumns]="[10, 30, 2]">
      <ng-template #header>
        <div class="w-full text-left ml-7">Tipo</div>
      </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="width-full text-left" [ngClass]="!item.status? 'inativo': ''">
          <span class="orange-text ml-7">{{ item.nameCategory }}</span>
        </div>
      </ng-template>

      <ng-template #header></ng-template>
      <ng-template #coluna let-item="dadosLinha"> </ng-template>

      <ng-template #header></ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="flex align-items-center justify-content-around mr-4">
          <ng-template [ngIf]="item.status && item.disableInactive != true">
            <p-button [rounded]="true" [text]="true" severity="orange-primary"
              (onClick)="$event.stopPropagation(); disableRevenue(item.id)" pTooltip="Inativar Receita">

              <ng-template pTemplate="icon">
                <div class="flex">
                  <split-icon name="ban" size="20"></split-icon>
                </div>
              </ng-template>
            </p-button>
          </ng-template>


          <ng-template [ngIf]="!item.status">

            <p-button [rounded]="true" [text]="true" severity="orange-primary"
              (onClick)="$event.stopPropagation(); enableRevenue(item.id)" pTooltip="Ativar Receita">
              <ng-template pTemplate="icon">

                <img src="assets/cadastro/active.svg" alt="ativar Receita" />
              </ng-template>
            </p-button>




            <!-- <button class="action border-circle bg-white h-2rem" (click)="enableRevenue(item.id)">
              <img src="assets/cadastro/active.svg" alt="ativar Receita" />
            </button> -->
          </ng-template>

        </div>
      </ng-template>
    </split-table>
  </div>
  <div *ngIf="!(isLoading$ | async)" class="col-12 m-0 p-0 mt-7 text-right">
    <p-button (onClick)="showForm()" class="ml-4" label="Adicionar receita"></p-button>
  </div>
</div>



<p-dialog [(visible)]="mostrarModalInativarReceitas" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
    <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem deletar unidade">
    <span class="title">
      <p>Tem certeza que deseja inativar</p>
      <p>essa Receita?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você inativará esse receita da sua listagem</p>
      <p>padrão.</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
    <button class="inativar" (click)="disableCard()">Inativar</button>
  </ng-template>

</p-dialog>

<p-dialog [(visible)]="mostrarModalAtivar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
    <img src="assets/cadastro/active_modal.svg" alt="imagem deletar unidade">
    <span class="title">
      <p>Tem certeza que deseja ativar</p>
      <p>essa Receita?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você irá ativar essa receita na sua listagem</p>
      <p>padrão</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
    <button class="ativar" (click)="enableCard()">Ativar</button>
  </ng-template>

</p-dialog>